import GiftingHeader from './GiftingHeader';

export default GiftingHeader;
